export default __webpack_public_path__ + "static/media/AIESC_Logo_Vertical_PNG.7e191540.png";